import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CdnImage from "../../../components/image/CdnImage";
import { useInnerSize } from "../../../hooks/useViewportHeight";
import Utils from "../../../utils/utils";
import "../styles/Banner.scss";
import { SwiperArrows } from "./SwiperArrows";

Modal.setAppElement("#root"); // Thiết lập phần tử gốc cho modal
// Sample data

interface BannerProps {
  banners: { image: string; link: string }[];
  bannerPopup: { image: string; link: string }[];
}

const HomeTopBanner: React.FC<BannerProps> = ({ banners, bannerPopup }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    const notShowBannerPopup = Cookies.get("notShowBannerPopup");
    if (notShowBannerPopup) {
      setIsModalOpen(!JSON.parse(notShowBannerPopup));
    } else {
      setIsModalOpen(true);
    }
  }, []);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { innerHeight, innerWidth } = useInnerSize();
  const h = innerWidth < 640 ? undefined : innerHeight * 0.7;
  const w =
    innerWidth < 640 ? "calc(100% - 24px)" : ((innerHeight * 0.7) / 992) * 608;

  const renderPopup = () => {
    if (!bannerPopup?.length) return null;
    return (
      <Modal
        isOpen={isModalOpen}
        contentLabel={t("Calendar Modal")}
        className={
          "banner-popup absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl" +
          (isModalVisible ? "" : " !hidden")
        }
        overlayClassName={"overlay" + (isModalVisible ? "" : " !hidden")}
        // style={{
        //   content: {
        //     height: h ? `${h}px` : undefined,
        //     width: typeof w == "string" ? w : `${w}px`,
        //   },
        // }}
      >
        <div className="bg-white">
          <Swiper
            modules={[Navigation, Pagination]}
            className="relative content-center items-center"
            // spaceBetween={Utils.remToPx(1.5)}
            pagination={{
              el: ".swiper-pagination-dots",
              type: "custom",
              renderCustom: (_: any, current: number, total: number) => {
                return `<div class="flex items-center px-[10px] py-[0] gap-[8px] h-[24px] bg-[rgba(13,_12,_17,_0.2)] rounded-[30px] w-fit mx-auto">
                  ${Array.from(
                    { length: total },
                    (_, i) =>
                      `<span class="size-2 rounded-full ${
                        i === current - 1
                          ? "bg-[#FFFFFF]"
                          : "border border-[#FFFFFF] opacity-40"
                      }"></span>`,
                  ).join("")}
                </div>`;
              },
            }}
            autoplay={{ delay: 4000 }}
            style={{
              maxHeight: "calc(100vh - 72px - 32px)",
              width: "calc(100dvw - 32px)",
              maxWidth: 400,
              aspectRatio: "328/430",
            }}
            // style={{
            //   height: h ? `${h - 72}px` : undefined,
            //   width: typeof w == "string" ? "100%" : `${w}px`,
            // }}
          >
            {bannerPopup.map((banner, index) => (
              <SwiperSlide
                key={index}
                className="my-auto w-full content-center"
              >
                <a className="h-full w-full" href={banner.link}>
                  <CdnImage
                    onLoad={() => setIsModalVisible(true)}
                    className="mx-auto h-full w-full object-cover"
                    src={banner.image}
                    alt=""
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchPriority={index === 0 ? "high" : "low"}
                    // style={{
                    //   height: h ? `${h - 72}px` : undefined,
                    //   width: typeof w == "string" ? "100%" : `${w}px`,
                    // }}
                    cdnParams={{
                      format: "webp",
                    }}
                  />
                </a>
              </SwiperSlide>
            ))}
            <div className="swiper-pagination-dots bg-red absolute bottom-3 left-[50%] z-10 -translate-x-1/2"></div>
          </Swiper>
          <div className="flex h-[4.5rem] items-center justify-between px-4">
            <label className="flex items-center text-[1.125rem] font-normal leading-[1.5325rem] text-[#232323]">
              {" "}
              <input
                onChange={(e) => {
                  Cookies.set(
                    "notShowBannerPopup",
                    JSON.stringify(e.target.checked),
                    { expires: 1 },
                  ); // Set cookie with 7 days expiration
                }}
                type="checkbox"
                className="custom-checkbox mr-2"
              />
              {t("Don’t show in 24 hours")}
            </label>

            <button
              className="flex justify-center text-[1.125rem] font-semibold leading-[1.5325rem] text-[#232323]"
              onClick={closeModal}
            >
              {t("Close")}
            </button>
          </div>
        </div>
      </Modal>
    );
  };
  return (
    <>
      {renderPopup()}
      <div className="banner relative mx-auto mt-10 min-h-[153px] sm:min-h-[360px] lg:mt-20">
        {!!banners?.length && (
          <>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={Utils.remToPx(1.5)}
              pagination={true}
              navigation={{
                nextEl: "#rcmd-banner-next",
                prevEl: "#rcmd-banner-prev",
              }}
              autoplay={{ delay: 5000 }}
              loop={true}
            >
              {(banners ?? []).map((banner, index) => (
                <SwiperSlide key={index} className="content-center">
                  {banner.link ? (
                    <a
                      className="h-full"
                      href={banner.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <CdnImage
                        className="mx-auto h-[153px] w-full max-w-[1160px] rounded-[1.25rem] object-cover sm:h-[22.5rem]"
                        src={banner.image}
                        alt="top banners"
                        loading={index === 0 ? "eager" : "lazy"}
                        cdnParams={{
                          format: "webp",
                          width: 1200,
                        }}
                      />
                    </a>
                  ) : (
                    <CdnImage
                      className="mx-auto h-[153px] w-full max-w-[1160px] rounded-[1.25rem] object-cover sm:h-[22.5rem]"
                      src={banner.image}
                      alt="top banners"
                      loading={index === 0 ? "eager" : "lazy"}
                      cdnParams={{
                        format: "webp",
                        width: 1200,
                      }}
                    />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
            <SwiperArrows />
          </>
        )}
      </div>
    </>
  );
};
export default HomeTopBanner;
